/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ credits: NonNullable<unknown> }} Property_Registry_Cee_ChargedInputs */

const cs_property_registry_cee_charged = /** @type {(inputs: Property_Registry_Cee_ChargedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CEE zkontrolováno (−${i?.credits} kreditů)`)
};

const en_property_registry_cee_charged = /** @type {(inputs: Property_Registry_Cee_ChargedInputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`CEE checked (−${i?.credits} credits)`)
};

/**
* | output |
* | --- |
* | "CEE checked (−{credits} credits)" |
*
* @param {Property_Registry_Cee_ChargedInputs} inputs
* @param {{ locale?: "cs" | "en" }} options
* @returns {LocalizedString}
*/
export const property_registry_cee_charged = /** @type {((inputs: Property_Registry_Cee_ChargedInputs, options?: { locale?: "cs" | "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Property_Registry_Cee_ChargedInputs, { locale?: "cs" | "en" }, {}>} */ ((inputs, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_property_registry_cee_charged(inputs)
	return cs_property_registry_cee_charged(inputs)
});